import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import FundkyButton from './FundkyButton';
import { translate } from 'react-i18next';
import cancelAndSaveButtonsEN from './locales/CancelAndSaveButtons_en.json';
import cancelAndSaveButtonsFR from './locales/CancelAndSaveButtons_fr.json';

import './CancelAndSaveButtons.less';

class CancelAndSaveButtons extends React.Component {

  constructor(props) {
    super(props);

    i18next.addResourceBundle('en', 'CancelAndSaveButtons', cancelAndSaveButtonsEN);
    i18next.addResourceBundle('fr', 'CancelAndSaveButtons', cancelAndSaveButtonsFR);
  }

  render() {
    const { t, className, size, onClickCancel, onClickSave, isSavingInProgress, disabled } = this.props;

    return (
      <div className={`${className} CancelAndSaveButtons CancelAndSaveButtons__wrap`}>
        <FundkyButton
          text={t('Cancel')}
          type="cancel"
          className="CancelAndSaveButtons--cancel"
          size={size}
          action={onClickCancel && {
            func: onClickCancel
          } || null}
          disabled={disabled || null}
        />
        <FundkyButton
          text={t('Save')}
          type="primary"
          className="CancelAndSaveButtons--save"
          size={size}
          icon={['fal', 'save']}
          loading={isSavingInProgress}
          action={onClickSave && {
            func: onClickSave
          } || null}
          disabled={disabled || null}
        />
      </div>
    );
  }

}

CancelAndSaveButtons.propTypes = {
  className: PropTypes.string,
  onClickCancel: PropTypes.func,
  onClickSave: PropTypes.func,
  isSavingInProgress: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

CancelAndSaveButtons.defaultProps = {
  className: '',
  onClickCancel: null,
  onClickSave: null,
  isSavingInProgress: false,
  size: "medium",
}

export default translate('CancelAndSaveButtons')(CancelAndSaveButtons);
